import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Box,Container,Typography!=!/app/node_modules/@mui/material/index.js");
import(/* webpackMode: "eager" */ "/app/clients/athena/src/app/terms/TermsBanner.tsx");
import(/* webpackMode: "eager" */ "/app/clients/athena/src/components/Spacing.tsx")